import {get_token,get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import Loader from "@/components/Loader/LoaderView";
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

const domain = window.location.hostname;


export default {
  components: {
    HomeNavBar,
    Loader,
    MenuSideBar,
    StickyNav,
    InactivityModal
  },
  data() {
    return ({
      token_exists:false,
      businessSearch: '',
      selectedNameFilter: '',
      selectedLocationFilter: '',
      selectedRatingFilter: '',
      business_profiles:[],
      profile_domain:false,
      cbo_domain:false,
      user_details: {
        "user_role": '',
      },
    })
  },
  computed: {
    filteredBusinesses() {
      return this.business_profiles.filter(b => {
        return (
          (!this.businessSearch || b.company_name.toLowerCase().includes(this.businessSearch.toLowerCase())) &&
          (!this.selectedNameFilter || b.company_name === this.selectedNameFilter)
          // Add location/rating filters as needed
        );
      });
    }
  },
  mounted() {

    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchCompanyProfile();
    if(domain.includes('tdm') || domain.includes('chamber') || domain.includes('staging') || domain.includes('uat.workstreams')){
      this.profile_domain=true
    }
    if(domain.includes('cbo')){
      this.cbo_domain=true}
  },

  methods: {
    getToken() {
      return get_token();
    },
    fetchCompanyProfile() {
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_company_profile/`,
            type: "POST",
            headers: {
                Authorization: `Token ${get_token()}`,
                "Content-Type": "application/json",
            },
            success: (response) => {
                if (response.status === "success") {
                 this.business_profiles=response.data
                }
            },
            error: (xhr, status, error) => {
                console.error("Error fetching company profile:", error);
         
            }
        });
      },
      view_profile(profile){
        const base = profile.base_profile.id;
        const type = profile.base_profile.profile_type;
        window.location.href = `/customer_profile?base=${base}&type=${type}`;
      }

    },
  

};